<template>
  <v-row justify="center">
    <v-btn color="accent shadow-4 px-8" rounded large @click.stop="dialog = true">Añadir Usuario</v-btn>

    <v-dialog v-model="dialog" persistent scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-progress-linear v-if="loading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Nuevo usuario
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                      <v-text-field
                        autofocus
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre"
                        name="nombre"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="info"
                        v-model="UserName"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="correo" rules="email|required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Correo electrónico"
                        name="email"
                        prepend-inner-icon="mdi-email"
                        type="text"
                        color="info"
                        v-model="UserEmail"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="contraseña" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Contraseña"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        color="info"
                        v-model="UserPassword"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>

                    <v-slide-y-transition>
                      <p v-if="UserPassword" class="grey--text caption pb-3">
                        <v-icon small left color="blue-grey">mdi-information</v-icon>Recuerde anotar la contraseña para
                        entregársela al usuario.
                      </p>
                    </v-slide-y-transition>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="rol de acceso" rules="required" v-slot="{ errors }">
                      <v-select
                        :items="options"
                        item-text="label"
                        item-value="value"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Rol de acceso"
                        name="rol"
                        prepend-inner-icon="mdi-briefcase"
                        color="info"
                        v-model="UserRol"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="UserRol === 10">
                    <ValidationProvider name="Extensiones del usuario" v-slot="{ errors }">
                      <v-select
                        :items="userExtensionOptions"
                        :loading="isLoadingExtensionItems"
                        multiple
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Extensiones del usuario"
                        name="rol"
                        prepend-inner-icon="mdi-briefcase"
                        color="blue-grey"
                        v-model="selectedUserExtensions"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                    <ValidationProvider name="Colas del usuario" v-slot="{ errors }">
                      <v-select
                        :items="queueItems"
                        :loading="isLoadingQueueItems"
                        item-text="name"
                        item-value="id"
                        multiple
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Colas del usuario"
                        name="rol"
                        prepend-inner-icon="mdi-briefcase"
                        color="blue-grey"
                        v-model="selectedUserQueues"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <!-- Filtrar mensajes por cola -->
                  <v-col cols="12">
                    <v-checkbox class="mt-0 ml-2" v-model="enable_queues_chat" :false-value="0" :true-value="1">
                      <template v-slot:label>
                        Filtrar mensajes por cola
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" v-if="UserRol === 3 || UserRol === 8">
                    <ValidationProvider name="colas" rules="required" v-slot="{ errors }">
                      <v-select
                        multiple
                        :disabled="isLoadingQueueItems"
                        :items="queueItems"
                        :item-text="(item) => `${item.name} (${item.number})`"
                        item-value="number"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Colas"
                        name="Colas"
                        prepend-inner-icon="mdi-database"
                        color="info"
                        v-model="queueSelected"
                        :error-messages="errors"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item ripple @mousedown.prevent @click="toggle">
                            <v-list-item-action>
                              <v-icon :color="queueSelected.length > 0 ? 'indigo darken-4' : ''">
                                {{ icon }}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                Seleccionar todo
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-select>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="UserRol === 3">
                    <ValidationProvider name="Prioridad" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Prioridad"
                        name="priority_order"
                        prepend-inner-icon="mdi-alert"
                        type="text"
                        color="info"
                        v-model="UserPriority"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="UserRol === 3 || UserRol === 8">
                    <ValidationProvider name="extensión" rules="required" v-slot="{ errors }">
                      <v-autocomplete
                        :disabled="isLoadingExtensionItems"
                        :items="extesionItems"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Extensión"
                        name="Extensión"
                        prepend-inner-icon="mdi-database"
                        color="info"
                        v-model="extesionSelected"
                        :error-messages="errors"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="UserRol === 3 || UserRol === 8">
                    <ValidationProvider name="extensión opcional" v-slot="{ errors }">
                      <v-autocomplete
                        :disabled="isLoadingExtensionItems"
                        :items="extesionOptItems"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Extensión opcional"
                        name="Extensión opcional"
                        prepend-inner-icon="mdi-database"
                        color="info"
                        v-model="extesionOptSelected"
                        :error-messages="errors"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="[1].includes(Role)">
                    <ValidationProvider name="clientes" rules="required" v-slot="{ errors }">
                      <v-autocomplete
                        :items="clients"
                        item-text="name"
                        item-value="id"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Cliente"
                        name="clients"
                        prepend-inner-icon="mdi-database"
                        color="info"
                        v-model="UserCliente"
                        :error-messages="errors"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" v-if="UserRol === 3 || UserRol === 8">
                    <v-checkbox
                      class="mt-0 ml-2"
                      v-model="auto_connection"
                      label="Conexión automática a planta"
                    ></v-checkbox>
                  </v-col>

                  <!-- <v-col cols="12" v-if="UserRol === 3 || UserRol === 8">
                    <v-checkbox
                      class="mt-0 ml-2"
                      v-model="auto_connection"
                      label="Puede firmar mensake"
                    ></v-checkbox>
                  </v-col> -->
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="eventdialog">Cancelar</v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(sendform)"
                >Añadir</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";
import { DIALOG_MAX_HEIGHT } from "@/utils";
import { accessRoleOptions } from "../assets";

import { mapState } from "vuex";
import { PbxHttpClient } from "@/services";
export default {
  components: {
    vuescroll,
  },

  data() {
    return {
      DIALOG_MAX_HEIGHT,
      showPassword: false,
      dialog: false,
      loading: false,
      isLoadingQueueItems: false,
      isLoadingExtensionItems: false,
      UserName: "",
      UserEmail: "",
      UserPassword: "",
      UserRol: "",
      UserCliente: "",
      UserPriority: 0,
      options: accessRoleOptions,
      clients: [],
      clients_id: "",
      queueItems: [],
      queueSelected: [],
      extesionItems: [],
      extesionOptItems: [],
      userExtensionOptions: [],
      selectedUserExtensions: [],
      selectedUserQueues: [],
      extesionSelected: null,
      extesionOptSelected: null,
      auto_connection: false,
      enable_queues_chat: 0,
    };
  },

  created() {
    this.Clients();
    this.getQueues();
    this.getExtension();

    if ([2].includes(this.Role)) {
      this.options.splice(0, 1);
    }
    if ([1].includes(this.Role)) {
      this.options = this.options.concat([
        {
          value: 4,
          label: "Calidad",
        },

        {
          value: 9,
          label: "Botones",
        },
      ]);
    }
  },

  computed: {
    icon() {
      if (this.likesAllQueues) return "mdi-close-box";
      if (this.likesSomeQueues) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    likesAllQueues() {
      return this.queueSelected.length === this.queueItems.length;
    },

    likesSomeQueues() {
      return this.queueSelected.length > 0 && !this.likesAllQueues;
    },

    Role() {
      return this.$store.getters["passport/GET_ROLE"];
    },

    ...mapState("role", ["roles"]),
  },

  watch: {
    extesionSelected(value) {
      this.extesionOptItems = this.extesionItems;
      this.extesionOptItems = this.extesionOptItems.filter((item) => item !== value);
    },
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllQueues) {
          this.queueSelected = [];
        } else {
          this.queueSelected = this.queueItems.map((item) => item.number);
        }
      });
    },

    resetform() {
      this.UserName = "";
      this.UserEmail = "";
      this.UserPassword = "";
      this.UserRol = 2;
      this.UserCliente = "";
      this.queueItems = [];
      this.queueSelected = [];
      this.extesionItems = [];
      this.extesionOptItems = [];
      this.extesionSelected = null;
      this.extesionOptSelected = null;
      this.auto_connection = false;
    },

    async sendform() {
      try {
        this.loading = true;
        const { data } = await this.$store.dispatch("user/CREATE_USER", {
          name: this.UserName,
          email: this.UserEmail,
          password: this.UserPassword,
          role_id: this.UserRol,
          client_id: this.UserCliente,
          queues: this.queueSelected,
          auto_connection: this.auto_connection,
          enable_queues_chat: this.enable_queues_chat,
          priority_order: this.UserPriority,
          extesion: this.extesionSelected === "Variable" ? 0 : this.extesionSelected,
          // extension_opcional:
          //   this.extesionOptSelected === "Variable"
          //     ? 0
          //     : this.extesionOptSelected,
        });
        if (data.role_id === 10) this.sendUserQueuesAndExtensions(data.id);
        this.$snotify.success("Usuario creado con éxito.", "¡Hecho!");
        this.loading = false;
        this.dialog = false;
        this.resetform();
      } catch (error) {
        this.$snotify.error("No se pudo crear el usuario.", "¡Error!");
        this.loading = false;
      }
    },

    async sendUserQueuesAndExtensions(userId) {
      const payload = {
        extensions: this.selectedUserExtensions.map((el) => String(el)),
        queuesIds: this.selectedUserQueues,
      };
      await PbxHttpClient.post(`/users/${userId}/assign-queues-extensions`, payload);
    },

    async Clients() {
      try {
        const response = await this.$store.dispatch("clients/SHOW_CLIENTS");
        this.clients = response.data;
      } catch (error) {
        // console.error(error);
        this.$snotify.error("No se pudo obtener listado de clientes.", "¡Error!");
      }
    },

    async getQueues() {
      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/listQueue`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.queueItems = res.data.data;
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("No se pudo obtener listado de colas.", "¡Error!");
        })
        .finally(() => {
          this.isLoadingQueueItems = false;
        });
    },

    async getExtension() {
      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/clients/listExtension`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          this.userExtensionOptions = [...new Set(res.data)];
          this.extesionItems = res.data;
          this.extesionOptItems = res.data;
          this.extesionItems.unshift("Variable");
        })
        .catch(() => {
          // console.error(error);
          this.$snotify.error("No se pudo obtener listado de extensiones.", "¡Error!");
        })
        .finally(() => {
          this.isLoadingExtensionItems = false;
        });
    },

    eventdialog() {
      this.resetform();
      this.dialog = false;
    },
  },
};
</script>
